import React from "react";
import PropTypes from "prop-types";
import Slider, { SliderTooltip } from "rc-slider";
import ProjectedBar from "../projectedBar/projectedBar";
import "rc-slider/assets/index.css";
import { asNumberString, formatGoalTitle } from "../../utils/formatters";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

export default class GoalListItem extends React.Component {
  constructor(props) {
    super(props);
    this.data = this.props.goalData;
    this.state = {
      showGoal: false,
      sliderValue: this.data.goalIncrease,
      enterValue: "",
      active: true,
      isEditMode: false,
      showSlider: true,
      currentProgress: 0,
      goalActive: this.data.active,
      currencySymbol: this.data.currencySymbol || "",
      usePercent: this.data.goalUsesPercent
    };
  }

  getEnterValue = () => {
    if (this.state.usePercent) {
      this.setState({
        enterValue: this.howMuchChanged(this.state.sliderValue, "percent", 0)
      });
    } else if (this.data.goalValue !== null && this.data.goalValue !== undefined) {
      this.setState({
        enterValue: this.data.goalValue.toFixed()
      });
    }
  };

  getNeededValue = () => {
    let enterValue = parseInt(this.state.enterValue);
    if (this.data.currentVal === 0) {
      return parseInt(enterValue);
    } else if (Math.sign(enterValue - this.data.currentVal) === -1) {
      return 0;
    } else {
      return Math.abs(enterValue - this.data.currentVal);
    }
  };

  getIncrease = () => {
    return (+this.state.sliderValue).toFixed(1)
  };

  howMuchChanged(val, typeOfVal = "percent", fixed) {
    const prev = this.data.prevPeriodVal;
    if (typeOfVal === "percent") {
      let goal = (prev * val) / 100 + prev;
      return goal.toFixed(fixed);
    } else if ((typeOfVal == "val")) {
      let increase = this.getPercentageDiff(val, this.data.isPercentageValue);
      return increase.toFixed(fixed);
    }
  }

  getPercentageDiff(value, isPercentageValue) {
    let enterVal = value || 0;
    let increaseInValue = enterVal - this.data.prevPeriodVal;
    let increaseInPercentage = (increaseInValue * 100) / this.data.prevPeriodVal;
    return isPercentageValue ? increaseInValue : increaseInPercentage;
  }

  logValue = (value) => {
    this.setState({
      sliderValue: value
    });
    this.getEnterValue();
  };

  onFormChange = (event) => {
    let formEnterValue = event.target.value;

    const limitUpTo100Percent = () => {
      let num = parseInt(formEnterValue, 10);
      return isNaN(num) ? "" : num <= 100 ? num.toString() : this.state.enterValue;
    };

    this.setState({
      enterValue: this.data.isPercentageValue
        ? limitUpTo100Percent()
        : formEnterValue.length > 7
        ? formEnterValue.slice(0, 7)
        : formEnterValue,
      sliderValue: this.howMuchChanged(formEnterValue, "val", 1)
    });
  };

  resetGoal = () => {
    this.setState({
      sliderValue: this.data.goalIncrease,
      enterValue: this.data.goalValue.toFixed(),
      isEditMode: false
    });
  };

  submitGoal = (id, value, active) => {
    this.props.saveGoal(id, value, active);
    this.setState({
      isEditMode: false,
      goalActive: active,
      enterValue: active ? this.state.enterValue : "",
      sliderValue: active ? this.state.sliderValue : 0
    });
    this.forceUpdate();
  };

  submitGoalAsNumber(id, value, active) {
    this.props.saveGoalAsValue(id, value, active);
    this.setState({
      isEditMode: false,
      goalActive: active
    });
    this.forceUpdate();
  }

  editMode = () => {
    this.setState({
      isEditMode: true
    });
  };

  handleTypeToggle = () => {
    this.setState({
      usePercent: !this.state.usePercent
    });
  };

  UNSAFE_componentWillMount() {
    this.getEnterValue();
  }

  onPaste(e) {
    e.preventDefault();
    return false;
  }

  onKeyPress(e) {
    if (e.which < 48 || e.which > 57) {
      e.preventDefault();
    }
  }

  formatClass(name) {
    name = name.replace(/\s+/g, "-").toLowerCase();
    return name;
  }

  render() {
    const { Handle } = Slider;

    const { isPercentageValue } = this.data;

    const handle = (props) => {
      const { value, dragging, index, ...restProps } = props;
      return (
        <SliderTooltip
          prefixCls="rc-slider-tooltip"
          overlay={value + "%"}
          visible={dragging}
          placement="top"
          key={index}
        >
          <Handle value={value} {...restProps} />
        </SliderTooltip>
      );
    };
    return (
      <div
        className={
          "goal-list-wrapper show " +
          (this.state.isEditMode ? "editActive" : "") +
          " " +
          this.formatClass(this.props.locationName) +
          " " +
          this.formatClass(formatGoalTitle(this.data.title)) +
          " metric-" +
          this.formatClass(this.props.metricName) +
          " " +
          (this.state.goalActive ? "active" : "inactive")
        }
        data-testid="goalListItem"
      >
        <div className="top">
          {!this.props.currentUser.singleLocation ? (
            <div className="region">
              <p>{this.data.locationName}</p>
            </div>
          ) : null}
          <div className="site">
            <span className="goal-name">{formatGoalTitle(this.data.title)}</span>
          </div>
          {this.state.goalActive || this.state.isEditMode ? (
            <div className="increase" data-testid="increase">
              {isFinite(this.getIncrease()) ? this.getIncrease() + "%" : "N/A"}
            </div>
          ) : null}
          <div className="goal" data-testid="goal">
            {this.state.goalActive || this.state.isEditMode ? (
              <div>
                <p>
                  {isPercentageValue
                    ? asNumberString(this.state.enterValue) + "%"
                    : this.state.currencySymbol + asNumberString(this.state.enterValue)}
                </p>
              </div>
            ) : null}
          </div>
          <div className="current">
            {this.state.goalActive || this.state.isEditMode ? (
              <div>
                <p>
                  {isPercentageValue
                    ? this.data.currentVal + "%"
                    : this.state.currencySymbol + asNumberString(this.data.currentVal)}
                </p>
              </div>
            ) : null}
          </div>
          <div className="forecast">
            {!isPercentageValue && (this.state.goalActive || this.state.isEditMode) ? (
              <div>
                <p>
                  {this.state.currencySymbol}
                  {asNumberString(this.data.currentValPacing)}
                </p>
              </div>
            ) : null}
          </div>
          <div className="needed" data-testid="needed">
            {!isPercentageValue && (this.state.goalActive || this.state.isEditMode) ? (
              <div>
                <p>
                  {this.state.currencySymbol}
                  {asNumberString(this.getNeededValue())}
                </p>
              </div>
            ) : null}
          </div>
          <div className="likely">
            {!isPercentageValue && (this.state.goalActive || this.state.isEditMode) ? (
              <div>
                <ProjectedBar
                  isAnimated={this.props.isAnimated}
                  metricTitle=""
                  value={this.data.currentVal / this.state.enterValue || 0}
                  projectedValue={this.data.currentValPacing / this.state.enterValue || 0}
                  hideMinus
                  currentVal={this.data.currentVal}
                  currentValPacing={this.data.currentValPacing}
                  currencySymbol={this.data.currencySymbol}
                  onMinusClick={() => {}}
                  isStacked
                />
              </div>
            ) : null}
          </div>
          <div className="action">
            {this.state.isEditMode ? (
              <FontAwesomeIcon
                className="times-circle"
                onClick={this.resetGoal}
                icon={faTimesCircle}
              />
            ) : null}
            {!this.state.isEditMode && this.props.currentUser.canModifyGoals ? (
              <button className="hollow-button" onClick={this.editMode}>
                {this.state.goalActive ? "MODIFY" : "SET"}
              </button>
            ) : null}
          </div>
        </div>
        <div className="bottom">
          <div className="prev-month">
            <p className="title">LAST MONTH</p>
            <p>
              {this.state.currencySymbol}
              {asNumberString(this.data.prevPeriodVal)}
            </p>
          </div>
          <div className="mtd">
            <p className="title">MONTH TO DATE</p>
            <p>
              {this.state.currencySymbol}
              {asNumberString(this.data.currentVal)}
            </p>
          </div>
          {isPercentageValue ? (
            ""
          ) : (
            <div className="month-last-year">
              <p className="title">MONTH LAST YEAR</p>
              <p>
                {this.state.currencySymbol}
                {asNumberString(this.data.prevYearVal)}
              </p>
            </div>
          )}

          <div className="enter-value">
            <p className="title">
              {isPercentageValue ? (
                "SET GOAL VALUE IN PERCENTS"
              ) : (
                <>
                  SET GOAL VALUE BY
                  <button
                    className={`hollow-button type ${this.state.usePercent && "editActive"}`}
                    onClick={() => this.handleTypeToggle()}
                  >
                    PERCENT
                  </button>
                  <button
                    className={`hollow-button type ${!this.state.usePercent && "editActive"}`}
                    onClick={() => this.handleTypeToggle()}
                  >
                    VALUE
                  </button>
                </>
              )}
            </p>
            {!isPercentageValue && this.state.showSlider && this.state.usePercent ? (
              <div className="slider">
                <Slider
                  handle={handle}
                  defaultValue={this.state.sliderValue}
                  onChange={this.logValue}
                  onAfterChange={this.logValue}
                  min={-20}
                  railStyle={{
                    background: "#bdbdbd",
                    height: "1px"
                  }}
                  trackStyle={{
                    background: "red",
                    height: "1px"
                  }}
                  handleStyle={{
                    borderColor: "white",
                    height: 28,
                    width: 28,
                    marginLeft: -14,
                    marginTop: -13,
                    backgroundColor: "white"
                  }}
                />
              </div>
            ) : null}
            {!this.state.usePercent ? (
              <div>
                <input
                  data-testid="enterValue"
                  className="manual-enter-number"
                  id={`enter-goal-value-${this.props.id}`}
                  type="number"
                  min="0"
                  value={this.state.enterValue}
                  onChange={this.onFormChange}
                  onPaste={this.onPaste}
                  onKeyPress={this.onKeyPress}
                />
              </div>
            ) : null}
          </div>

          <div className="action">
            {this.state.usePercent ? (
              <div>
                <button
                  className="hollow-button save"
                  onClick={() => this.submitGoal(this.data.id, this.state.sliderValue, true)}
                >
                  SAVE
                </button>
                {this.state.goalActive ? (
                  <button
                    className="hollow-button deactivate"
                    onClick={() => this.submitGoal(this.data.id, this.state.sliderValue, false)}
                  >
                    DEACTIVATE
                  </button>
                ) : null}
              </div>
            ) : (
              <div>
                <button
                  className="hollow-button save"
                  onClick={() => this.submitGoalAsNumber(this.data.id, this.state.enterValue, true)}
                >
                  SAVE
                </button>
                {this.state.goalActive ? (
                  <button
                    className="hollow-button deactivate"
                    onClick={() => this.submitGoal(this.data.id, this.state.sliderValue, false)}
                  >
                    DEACTIVATE
                  </button>
                ) : null}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

GoalListItem.propTypes = {
  goalData: PropTypes.object,
  value: PropTypes.number,
  dragging: PropTypes.bool,
  index: PropTypes.string,
  id: PropTypes.number,
  saveGoal: PropTypes.func,
  saveGoalAsValue: PropTypes.func,
  locationName: PropTypes.string,
  goalName: PropTypes.string,
  metricName: PropTypes.string,
  currencySymbol: PropTypes.string,
  currentUser: PropTypes.object,
  key: PropTypes.number,
  isAnimated: PropTypes.bool
};
